import { render } from "./NewPass.vue?vue&type=template&id=0730c262&scoped=true"
import script from "./NewPass.vue?vue&type=script&lang=js"
export * from "./NewPass.vue?vue&type=script&lang=js"

import "./NewPass.vue?vue&type=style&index=0&id=0730c262&lang=scss&scoped=true"

import exportComponent from "G:\\Programming\\VueProjects\\radinrealp2p\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0730c262"]])

export default __exports__